export default __webpack_public_path__ + "static/media/burger-menu.75e8db52.svg";